import { Injectable, OnDestroy } from '@angular/core';
import { versao } from 'environments/versao';
import { ToastrService } from 'ngx-toastr';

const INTERVALO_VERIFICACAO_MS = 5 * 60 * 1000;

@Injectable({
  providedIn: 'root'
})
export class VersaoService implements OnDestroy {

  /** Versão compilada no bundle carregado pelo navegador. */
  readonly versao = versao;

  private _intervalo: any;
  private _versaoNotificada: string;
  private readonly _aoVoltarParaAba = () => {
    if (document.visibilityState === 'visible') {
      this.verificaVersaoPublicada();
    }
  };

  constructor(private _toastr: ToastrService) { }

  /**
   * Compara a versão carregada com a publicada (assets/versao.json, sem cache) ao abrir o sistema,
   * a cada 5 minutos e ao voltar para a aba. Se forem diferentes, avisa o usuário para recarregar a página.
   * Em desenvolvimento (ng serve) não há versão publicada, então não verifica.
   */
  iniciaVerificacao() {
    if (this.versao.versao === 'dev' || this._intervalo) {
      return;
    }
    this.verificaVersaoPublicada();
    this._intervalo = setInterval(() => this.verificaVersaoPublicada(), INTERVALO_VERIFICACAO_MS);
    document.addEventListener('visibilitychange', this._aoVoltarParaAba);
  }

  ngOnDestroy(): void {
    clearInterval(this._intervalo);
    document.removeEventListener('visibilitychange', this._aoVoltarParaAba);
  }

  private async verificaVersaoPublicada() {
    try {
      // fetch em vez de HttpClient para não passar pelos interceptors da API
      const resposta = await fetch(`assets/versao.json?t=${Date.now()}`, { cache: 'no-store' });
      if (!resposta.ok) {
        return;
      }
      const publicada = await resposta.json();
      if (publicada?.versao && publicada.versao !== this.versao.versao && publicada.versao !== this._versaoNotificada) {
        this._versaoNotificada = publicada.versao;
        this.avisaNovaVersao(publicada.versao);
      }
    } catch (e) {
      // sem conexão ou arquivo indisponível: tenta de novo na próxima verificação
    }
  }

  private avisaNovaVersao(versaoPublicada: string) {
    this._toastr
      .info(
        `A versão ${versaoPublicada} foi publicada e você está usando a ${this.versao.versao}. Clique aqui para recarregar a página.`,
        'Nova versão disponível',
        {
          positionClass: 'toast-top-center',
          toastClass: 'toast ngx-toastr',
          closeButton: true,
          disableTimeOut: true,
          tapToDismiss: true
        }
      )
      .onTap.subscribe(() => window.location.reload());
  }
}
